module.exports = __webpack_public_path__ + "img/6062c3a.jpg";